module.exports = __webpack_public_path__ + "media/images/sp/stores/suns/magazine/section02_01_beach-photo-af93244a04b5a61b268aeb9ec950c881.jpg";